import { Button, Replay } from '@core/ui';
import { useTranslation } from 'react-i18next';

export const AppreciationPopup = ({ isOnDemand, onClick }: { isOnDemand: boolean; onClick?: () => void }) => {
    const { t } = useTranslation();

    return (
        <div data-testid="appreciationPopup" className="absolute inset-0 flex items-center justify-center bg-linear-to-b from-primary/95 to-primary/75 z-10">
            <div className="bg-white rounded-lg flex flex-col items-center m-2 p-4">
                <p>{t('Player.ThanksForWatching.Heading')}</p>
                <div className="flex flex-wrap gap-4 mt-5">
                    {isOnDemand && (
                        <Button variant="primary-outline" classNames="grow" onClick={onClick}>
                            <Replay classNames="size-6 me-2 stroke-current" />
                            {t('Player.ThanksForWatching.Button.Replay')}
                        </Button>
                    )}
                    <a href={t('Player.ThanksForWatching.Link.Url')} className="btn btn--primary grow">
                        {t('Player.ThanksForWatching.Link.Overview')}
                    </a>
                </div>
            </div>
        </div>
    );
};
